export enum TrackingLabel {
  // Configuration related
  StartConfiguration = 'start_configuration',
  EditConfiguration = 'edit_configuration',
  EngineChange = 'engine_change',
  ItemChange = 'item_change',
  LineToggle = 'line_toggle',

  // Load related
  FeasibilityLoad = 'feasibility_load',
  FeasibilityAbort = 'feasibility_abort',
  // TODO: This is a duplicate of TransferMotorization an unused - can be removed?
  // Load = 'load',
  LoadOnlinecode = 'load_onlinecode',
  Loaded = 'loaded',
  TransferMotorization = 'load',
  TransferMotorizationAbort = 'abort',
  TransferMotorizationTransferConfiguration = 'transfer_configuration',
  ResolveVehicleHeal = 'resolve_vehicle_heal',

  // Online code related
  OnlineCodeCopy = 'onlinecode_copy',
  OnlineCodeURL = 'onlinecode_url',
  OnlineCodeEMail = 'send_onlinecode_email',
  ResolveOnlineCode = 'resolve_online_code',

  // Vehicle related
  EngineConcept = 'engine_concept',
  Exterior360 = 'exterior360',
  Interior = 'interior',
  Lights = 'lights',
  Rooftop = 'rooftop',

  // Finance related
  Finance = 'finance',
  OpenFinanceLayer = 'open_finance_layer',
  NextStepsEditFinancing = 'edit_financing',

  // Navigation related
  NaviBar = 'navi_bar',
  NaviBarSubMenu = 'navi_bar.submenu',
  SummarySidebarReturnToConfig = 'return_to_configuration',

  // Package related
  ComparePackages = 'compare_packages',
  DependentPackage = 'dependent_package',
  IncludedItems = 'included_items',
  ConfiguredItems = 'configured_items',

  // Search related
  SearchOpen = 'search_open',
  SearchResultItemView = 'search_result.selected.item_view',

  // Miscellaneous
  BlueButton = 'blue_button',
  Close = 'close',
  Continue = 'continue',
  DeliveryDate = 'delivery_date',
  GeneratePdf = 'generate_pdf',
  Open = 'open',
  Slider = 'slider',
  LeftArrow = 'left_arrow',
  RightArrow = 'right_arrow',
  ShowMore = 'show_more',
  ShowMoreDetails = 'show_more_details',
  TechnicalDetails = 'technical_details',
  LimitUpdate = 'limit_update',

  // Next steps
  BuildToOrder = 'build_to_order',
  // TODO: This is a duplicate of OnlineShop an unused - can be removed?
  // NextStepsMatchingOffers = 'online_shop',
  NextStepsRequestVehicle = 'contact_dealer',
  NextStepsSave = 'save_to_account',
  OnlineShop = 'online_shop',

  // Upselling recommendations
  ResultsShown = 'owcc.recommendations.results'
}
